<template>
  <div class="eyeHabit">
    <div class="back">
      <div class="title">正确坐姿</div>
      <div class="videoGroup" >
        <img @click="videoClick" class="video" src="../../assets/img/drive.png" />
      </div>
      <div class="btnGroup" >
        <button @click="go" style="display: none">返回</button>
        <button @click="penClick">握笔姿势</button>
      </div>
    </div>
    <el-dialog
        title=""
        class="sp"
        :visible.sync="showsp"
        width="80%"
        :destroy-on-close="true"
    >
      <video style="width: 100%" controls autoplay="autoplay" loop="loop">
        <source src="http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/Resource/WebDemo/video/eye_habit.mp4" type="video/mp4">
        <source src="http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/Resource/WebDemo/video/eye_habit.mp4" type="video/ogg">
        您的浏览器不支持Video标签。
      </video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "eyeHabit",
  data() {
    return {
      showsp: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    go() {
      this.$router.go(-1);
    },
    videoClick() {
      this.showsp = true
    },
    penClick() {
      this.$router.push({path: '/PopularScienceHome/penPosture'});
    }
  }
}
</script>

<style scoped lang="scss">
  .eyeHabit {
    width: 100%;
    height: 100%;
    background: url("http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/Resource/WebDemo/pic/pedia_background.jpg") no-repeat center center;
    background-size: cover;
  }
  .back {
    position: relative;
    height: 100%;
    background: url("http://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/Resource/WebDemo/pic/sitdown_post.png") no-repeat center center;
    background-size: contain;
  }
  .title {
    line-height: 40px;
    font-weight: 600;
    font-size: 18px;
  }
  .videoGroup {
    width: 100%;
    position: absolute;
    bottom: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video {
    width: 45px;
    height: 45px;
  }
  .btnGroup {
    width: 100%;
    position: absolute;
    bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btnGroup button {
    margin: 15px 30px;
    padding: 10px 80px;
    background: transparent;
    border: 1px solid #333;
    color: #333;
    font-size: 18px;
  }

  .sp {
    display: flex;
    align-content: center;
    justify-content: center;
  }
  ::v-deep .sp .el-dialog {
    margin: 5vh !important;
    height: 90vh;
    //margin-top: 10vh;
  }
</style>
